import { render } from "./g-steps.vue?vue&type=template&id=dba65136&scoped=true"
import script from "./g-steps.vue?vue&type=script&lang=js"
export * from "./g-steps.vue?vue&type=script&lang=js"

import "./g-steps.vue?vue&type=style&index=0&id=dba65136&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba65136"]])

export default __exports__